import { AutoInvalidationConfig, getDefaultQueryClient } from '@repo/shared-core-utilities-react-query/default-query-client'

export const bullmqQueryClient = getDefaultQueryClient()

const autoInvalidationConfig: AutoInvalidationConfig = [
  { mutationKey: 'redis', queryKeys: ['redis'] },
  { mutationKey: 'queue', queryKeys: ['queue'] },
  { mutationKey: 'queue-config', queryKeys: ['queue-config'] },
  { mutationKey: 'queue-monitors', queryKeys: ['queue-monitors'] },
  { mutationKey: 'queue-alerts', queryKeys: ['queue-alerts'] },
  { mutationKey: 'queue-metrics', queryKeys: ['queue-metrics'] },
  { mutationKey: 'queue-workers', queryKeys: ['queue-workers'] },
  { mutationKey: 'jobs', queryKeys: ['jobs', 'queue-counts'] },
  { mutationKey: 'job-logs', queryKeys: ['job-logs'] },
  { mutationKey: 'scheduled-jobs', queryKeys: ['scheduled-jobs', 'queue'] },
  { mutationKey: 'user', queryKeys: ['user'] },
  { mutationKey: 'user-preferences', queryKeys: ['user-preferences'] },
  {
    mutationKey: 'obliterate-queue',
    queryKeys: ['queue', 'jobs', 'scheduled-jobs', 'queue-alerts', 'queue-config', 'queue-monitors', 'queue-metrics', 'queue-workers']
  }
]

for (const config of autoInvalidationConfig) {
  bullmqQueryClient.setMutationDefaults([config.mutationKey], {
    onSuccess: async () => {
      for (const queryKey of config.queryKeys) {
        await bullmqQueryClient.invalidateQueries({ queryKey: [queryKey] })
      }
    }
  })
}
